import { useEffect } from 'react';
import { useLogout } from 'hooks/use-logout/use-logout';
import { httpClient } from 'sync/request';

export const useAutoLogout = () => {
  const logout = useLogout();

  useEffect(() => {
    const interceptor = httpClient.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.status === 401 && error.response.config.url !== '/sessions') {
          logout();
        }
        return Promise.reject(error);
      }
    );
    return () => httpClient.interceptors.response.eject(interceptor);
  }, [logout]);
};
